
 export default function validateProfile(values,pass) {
    let errors = {};
    if (!values.email) {

      errors.email = 'Email is Required';
    } 
    else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = 'Email address is invalid';
    }

    if (!values.name) {

        errors.name = 'Name is Required';
    }       
    return errors;
  };

//Destination Validation******************************


  export function DestinationValidation(values,pass){
    let errors = {};
    if(!values.name){
      errors.name="Name is Required";
    }else if(values.name.length < 8){
      errors.name = "Name must be 8 or more characters"
    }
    if(!values.about){
      errors.about = "About Field is required";
    }else if(values.about.length < 10){
      errors.about = "About must be 100 or more characters";
    }
    if(!values.nickname){
      errors.nickname = "About Field is required";
    }
    if(!values.country){
      errors.country = "Country Field is required";
    }
    if(!values.image){
      errors.image = "Image Field is required";
    }
    if(!values.thumbnail){
      errors.thumbnail = "thumbnail is required";
    }
       
    return errors;
  }


  //Destination Validation******************************


  export function UpdateDestinationValidation(values,pass){
    let errors = {};
    if(!values.name){
      errors.name="Name is Required";
    }else if(values.name.length < 8){
      errors.name = "Name must be 8 or more characters"
    }
    if(!values.about){
      errors.about = "About Field is required";
    }else if(values.about.length < 10){
      errors.about = "About must be 100 or more characters";
    }
    if(!values.nickname){
      errors.nickname = "About Field is required";
    }
    if(!values.country){
      errors.country = "Country Field is required";
    }
    if(!values.image){
      errors.image = "Image Field is required";
    }
    if(!values.thumbnail){
      errors.thumbnail = "thumbnail is required";
    }
       
    return errors;
  }

    //Commission Validation******************************


    export function commissionvalidation(values,pass){
      //console.log(values)
      let errors = {};
      if(!values.trawex_flight){
        errors.trawex_flight="Flight Commission is Required";
      }else if(values.trawex_flight >= 100 || values.trawex_flight < 0){
        errors.trawex_flight = "Value must be between 0 to 100"
      }
      // if(!values.ticket_master){
      //   errors.ticket_master="Ticket Master Commission is Required";
      // }else if(values.ticket_master >= 100 || values.ticket_master < 0){
      //   errors.ticket_master = "Value must be between 0 to 100"
      // }
      if(!values.hotelbeds){
        errors.hotelbeds="Hotel Beds Commission is Required";
      }else if(values.hotelbeds >= 100 || values.hotelbeds < 0){
        errors.hotelbeds = "Value must be between 0 to 100"
      }
      if(!values.tbo){
        errors.tbo="TBO Commission is Required";
      }else if(values.tbo >= 100 || values.tbo < 0){
        errors.tbo = "Value must be between 0 to 100"
      }
         //console.log(errors);
      return errors;
    }


// WEBPACK FOOTER //
// ./src/Pages/Auth/UpdateValidation.js